import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "",
  style: {"line-height":"1.25"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { class: "d-flex align-items-center text-hover-primary cursor-pointer" }
const _hoisted_4 = { class: "symbol symbol-30 symbol-light-success me-3" }
const _hoisted_5 = {
  class: "text-dark-50",
  style: {"line-height":"1.25"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_8 = {
  key: 1,
  class: "badge badge-light-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: `${_ctx.t('selection')} ${_ctx.sport?.name}`,
    modelValue: _ctx.gblDialog,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.gblDialog) = $event)),
    class: "bg-light",
    onOpened: _ctx.onOpened,
    onClosed: _ctx.onClosed,
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    top: "0vh",
    draggable: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_input, {
        modelValue: _ctx.searchText,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
        size: "large",
        placeholder: _ctx.t('search'),
        "prefix-icon": _ctx.Search,
        disabled: _ctx.loaderTable,
        clearable: "",
        class: "w-100 mb-4"
      }, null, 8, ["modelValue", "placeholder", "prefix-icon", "disabled"]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: _ctx.filteredList,
        border: "",
        style: {"width":"100%"},
        height: _ctx.altura <= 500 ? '500px' : _ctx.altura + 'px'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "docnumber",
            label: _ctx.t('document'),
            width: "120"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("span", null, _toDisplayString(scope.row.docname), 1),
                _hoisted_2,
                _createElementVNode("span", null, _toDisplayString(scope.row.docnumber), 1)
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "persona",
            label: _ctx.t('participant'),
            width: "250"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_avatar, {
                    shape: "square",
                    size: "small",
                    fit: "contain",
                    src: `${_ctx.repo}/uploads/${scope.row.photo}`,
                    class: _normalizeClass('border')
                  }, null, 8, ["src"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", null, _toDisplayString(scope.row.firstname), 1),
                  _hoisted_6,
                  _createElementVNode("span", null, _toDisplayString(scope.row.lastname + ' ' + scope.row.surname), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "gender",
            label: _ctx.t('gender'),
            width: "80",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              (scope.row.gender == 'M')
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(scope.row.gender), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(scope.row.gender), 1))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "edad",
            label: _ctx.t('age'),
            align: "center"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, { align: "center" }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                size: "small",
                type: "success",
                round: "",
                onClick: ($event: any) => (_ctx.setSelectRow(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('select')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "height"])), [
        [_directive_loading, _ctx.loaderTable]
      ])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "onOpened", "onClosed"]))
}